import React, { Component } from 'react';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';

import './App.css';

const events = [
    {
     id: 0,
     title: 'All Day Event very long title',
     allDay: true,
     start: new Date(2015, 3, 0),
     end: new Date(2015, 3, 1),
    },
    {
     id: 1,
     title: 'Long Event',
     start: new Date(2015, 3, 7),
     end: new Date(2015, 3, 10),
    }
];
let allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k])

BigCalendar.momentLocalizer(moment); // or globalizeLocalizer

class Calendar extends Component {
  render() {
    return (
      <div className="calendar-container">
        <div className="page-heading"> Calendar of Events </div>
        <div className="actual-calendar">
          <BigCalendar
            events={events}
            views={allViews}
            step={60}
            showMultiDayTimes
            defaultDate={new Date(2015, 3, 1)}
          />
        </div>
      </div>
    );
  }
}

export default Calendar;



/** WEBPACK FOOTER **
 ** ./src/Calendar.js
 **/